const roles = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  ANALYST: 'ANALYST',
  TEAM_LEADER: 'TEAM_LEADER',
  OPERATOR: 'OPERATOR',
  CUSTOMER: 'CUSTOMER',
  PUBLISHER: 'PUBLISHER',
  SALE: 'SALE',
};

export default roles;
